<script setup lang="ts">
import { Avatar as VarAvatar, type AvatarProps } from '@varlet/ui';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<AvatarProps>();
</script>

<template>
  <VarAvatar v-bind="props">
    <slot />
  </VarAvatar>
</template>
